import styled from 'styled-components';
import { darkgrey, grey } from 'styles/Colors';

export const Title = styled.div`
  color: ${darkgrey};
  font-family: Lato;
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
`;

export const Content = styled.div`
  margin-top: 6px;
  color: ${grey};
  font-family: Lato;
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const Example = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #a0a0a0;
  font-size: 11px;
  font-weight: 400;
  line-height: 15.4px;
`;

export const ExampleDot = styled.div`
  height: 10px;
  width: 10px;
  background-color: #fe9800;
  border-radius: 2px;
`;
